import { Schema } from "rsuite";

import {
    EntitySetting,
    SettingType,
} from "store/environments/tenants/data-import/data-import-types";
import { descriptions, rules, SettingRule } from "./definitions";

export type SettingsFormValue = Record<string, string | number>;

export const toFormValue = (
    settings: Record<string, EntitySetting> | null
): SettingsFormValue =>
    Object.entries(settings ?? {}).reduce<SettingsFormValue>(
        (acc, [key, setting]) => {
            if (!descriptions.has(key)) {
                return acc;
            }

            const parsed = Number(setting.value);

            acc[key] =
                setting.type === SettingType.Number &&
                setting.value !== "" &&
                Number.isFinite(parsed)
                    ? parsed
                    : setting.value;

            return acc;
        },
        {}
    );

export const toEntitySettings = (
    formValue: SettingsFormValue,
    source: Record<string, EntitySetting> | null
): Record<string, EntitySetting> =>
    Object.entries(source ?? {}).reduce<Record<string, EntitySetting>>(
        (acc, [key, setting]) => {
            const raw = formValue[key];

            acc[key] =
                raw === undefined || raw === null
                    ? { ...setting }
                    : { ...setting, value: String(raw).trim() };

            return acc;
        },
        {}
    );

export const toModel = (settings: Record<string, EntitySetting> | null) => {
    const model = Object.entries(settings ?? {}).reduce<
        Record<string, SettingRule>
    >((acc, [key]) => {
        const rule = rules.get(key);

        if (!rule) {
            return acc;
        }

        acc[key] = rule;

        return acc;
    }, {});

    return Schema.Model<SettingsFormValue, string>(model);
};
